export default "__VITE_ASSET__B5W2bF7n__"